($ => {

  function getTextWidth(text, font, UC) {
    var f = font;
    if(UC){
      var o = $('<span>' + text + '</span>')
        .css({'font': f, 'float': 'left', 'white-space': 'nowrap', 'display':'block', 'text-transform': 'uppercase' })
        .appendTo($('body'));
    }else{
      var o = $('<span>' + text + '</span>')
        .css({'font': f, 'float': 'left', 'white-space': 'nowrap', 'display':'block'})
        .appendTo($('body'));
    }

    var w = o.width();

    o.remove();

    return w;
  }

  $.fn.tableTooltip = function () {
    this.on('mouseenter', 'th:not(.not-tooltip), td:not(.not-tooltip)', function () {
      var $this = $(this);
      var container = this;
      var title = $this.text();
      //padding
      var extra_space = 10;
      if($this.is('th') && $this.hasClass('sort')){
        //tamaño flecha ordenar + padding flecha ordenar + padding elemento
        extra_space = 8 + 10 + 10;
      }else if($this.is('th')){
        //padding + border
        extra_space += 2;
      }else if($this.is('td')){
        //padding + border
        extra_space += 2;
      }
      if ($this.hasClass('td-btn')) {
        container = $this.find('input')[0];
        title = $(container).val();
      }else if($this.find('a').length > 0){
        container = $this.find('a')[0];
      }

      if (container.offsetWidth  < container.scrollWidth || container.offsetWidth  < (getTextWidth(title, $this.css('font'), $this.is('th')) + extra_space)) {
        if ($this.data && !$this.data('bs.tooltip')) {
          $this.tooltip({
            title: title,
            placement: 'bottom',
            container: 'body',
            trigger: 'manual',
          });
          $this.tooltip('show');
        }
      }
    });

    this.on('mouseleave', 'th:not(.not-tooltip), td:not(.not-tooltip)', function () {
      var $this = $(this);
      if ($this.data && $this.data('bs.tooltip')) {
        $this.tooltip('destroy');
      }
    });
  };
})(jQuery);


// WEBPACK FOOTER //
// ./source/assets/javascripts/plugins/table-tooltip.js